<template>
  <div>
    <div class="title font-size__medium">Lịch sử xử lý</div>
    <el-table :data="histories" :show-header="false">
      <el-table-column type="index"></el-table-column>
      <el-table-column property="value" show-overflow-tooltip>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import h from "../../../services/h";

export default {
  name: "tdhvp-doc-histories",
  props: ["tdhvpHistory"],

  data() {
    return {
      histories: []
    };
  },

  watch: {
    tdhvpHistory() {
      this.initHistories();
    }
  },

  created() {
    this.initHistories();
  },

  methods: {
    initHistories() {
      this.histories = h.findAll(
        h.collect((this.tdhvpHistory || "").split("<br>"), item => {
          return { value: (item || "").trim() };
        }),
        item => !!item.value
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/common/tdhvp-doc-histories.vue